export function item(state, data) {
  state.item = data
}

export function items(state, data) {
  state.items = data
}